import { render, staticRenderFns } from "./TabCambioButaca.vue?vue&type=template&id=1d66e6ed"
import script from "./TabCambioButaca.vue?vue&type=script&setup=true&lang=js"
export * from "./TabCambioButaca.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports